"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _cccisdReactRouter = require("cccisd-react-router");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CustomLink = function CustomLink(props) {
  var to = props.to;
  if (typeof to === 'string' && /^http/.test(to)) {
    return /*#__PURE__*/_react["default"].createElement("a", _extends({
      href: to
    }, (0, _omit2["default"])(props, ['to'])), props.children);
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Link, props, props.children);
};
CustomLink.propTypes = {
  to: _propTypes["default"].string,
  children: _propTypes["default"].node
};
CustomLink.defaultProps = {};
var _default = exports["default"] = CustomLink;